import * as React from 'react';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import styles from './Json.css';

interface JsonProps {
	placeholder: Object;
	handleChangeJsonEditorValue: (json: any) => void;
}

const Json: React.FunctionComponent<JsonProps> = ({ placeholder, handleChangeJsonEditorValue }) => (
	<div className={styles.jsonContainer}>
		<JSONInput
			id="json_input"
			placeholder={placeholder}
			locale={locale}
			height="100%"
			width="100%"
			borderRadius="20px"
			confirmGood={false}
			colors={{
				background: '#1D1E22',
				string: '#9CB28E',
				keys: '#DACA88',
			}}
			style={{
				container: {
					borderRadius: '20px',
					fontSize: '72px',
				},
				body: {
					height: 'calc(100% - 52px)',
					padding: '24px 12px',
					color: 'rgb(51, 51, 51)',
				},
			}}
			onChange={handleChangeJsonEditorValue}
		/>
	</div>
);

export default Json;
